import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTour, addDiscount } from "../slices/tourSlice";
import Success from "./success";

const TourDetailAdmin = ({ isOpen, onClose, tour }) => {
  const dispatch = useDispatch();
  const { selectedTour, status, error } = useSelector((state) => state.tours);
  const [discount, setDiscount] = useState(false);
  const [formData, setFormData] = useState({
    tourId:tour.id,
    discountPrice:0
  });
  const [isSuccess, setIsSuccess] = useState(false);
  useEffect(() => {
    dispatch(getTour(tour.slug));
  }, [dispatch]);

  if (status === "loading") {
    return <div>Loading...</div>; // Yüklənir...
  }

  if (status === "failed") {
    return <div>Error: {error}</div>; // Xəta baş verib
  }

  if (!selectedTour) {
    return <div>No tour details available</div>; // Dəyişilən məlumat yoxdur
  }

  if (!isOpen) return null;

  const addDiscountTour = () => {
    dispatch(addDiscount(formData));
    if (status === "succeeded") {
      setIsSuccess(true);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div className="modal-overlay">
      <div style={{ width: "60vw", height: "50vw" }} className="modal-content">
        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
        <h2>{selectedTour.title}</h2>
        <h4>Turun yaranma tarixi : {selectedTour.createdAt.split("T")[0]}</h4>
        <div className="detailmodal-body">
          <h3>Əlavə edən əməkdaş : {selectedTour.userEmail}</h3>
          <h3>Əlavə edən əməkdaşın nömrəsi : {selectedTour.phonenumber}</h3>
          {selectedTour.isPrivate && <h3>Şəxsi tur : <span style={{color:"#ff6010"}}>https://joyfultravel.az/az/tour/{selectedTour.slug}</span></h3>}
          <div>
            <h3>Başlıq şəkli</h3>
            <img
              style={{ width: "6vw", height: "6vw" }}
              src={selectedTour.headerImageUrl}
              alt="image"
            />
          </div>
          <div>
            <h3>Tura aid şəkillər</h3>
            <ul>
              {selectedTour.tourGalleries.map((gallery) => {
                return (
                  <li>
                    <a>
                      <img
                        style={{ width: "6vw", height: "6vw" }}
                        src={gallery.imageUrl}
                        alt="image"
                      />
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          {selectedTour.currency === "USD" && <h3>Qiymət : {selectedTour.price} USD</h3>}
          {selectedTour.currency === "EUR" && <h3>Qiymət : {selectedTour.price} EUR</h3>}
          {selectedTour.currency === "AZN" && <h3>Qiymət : {selectedTour.price} AZN</h3>}
          {selectedTour.hasDiscount === true ? (
            <h3>Endirimli qiymət : {selectedTour.discountPrice}</h3>
          ) : (
            <a onClick={() => setDiscount(true)} className="discount-button">
              Endirim yarat
            </a>
          )}

          {discount && (
            <div>
              <input
                style={{ width: "10vw", marginRight: "45vw", marginTop: "1vw" }}
                type="number"
                placeholder="Endirimli qiymət"
                value={formData.discountPrice}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    discountPrice: parseInt(e.target.value) || 0
                  })
                }
                required
              />
              <div
                style={{
                  width: "10vw",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <a onClick={() => addDiscountTour()} className="okay-button">
                  Tətbiq et
                </a>
                <a onClick={() => setDiscount(false)} className="okay-button">
                  Ləğv et
                </a>
              </div>
            </div>
          )}

          <h3>Slug : {selectedTour.slug}</h3>

          <h3>Kateqoriya : {selectedTour.categoryName}</h3>
          <h3>Səyahət günləri : {selectedTour.duration}</h3>
          <h3>İstifadə olunan dillər : {selectedTour.language}</h3>
          <div>
            <h3>Otellər</h3>
            <ul
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                marginTop: "1vw",
              }}
            >
              {selectedTour.hotels.map((hotel) => {
                return (
                  <li>
                    <h3 style={{ color: "#ff6010" }}>{hotel.name} - {hotel.price}</h3>
                  </li>
                );
              })}
            </ul>
          </div>
          <div>
            <h3>Daxil olan özəlliklər</h3>
            <ul
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                marginTop: "1vw",
              }}
            >
              {selectedTour.includedFeatures.map((features) => {
                return (
                  <li>
                    <h3 style={{ color: "#ff6010" }}>{features.name}</h3>
                  </li>
                );
              })}
            </ul>
          </div>
          <div>
            <h3>Daxil olmayan özəlliklər</h3>
            <ul
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
                marginTop: "1vw",
              }}
            >
              {selectedTour.excludedFeatures.map((features) => {
                return (
                  <li>
                    <h3 style={{ color: "#ff6010" }}>{features.name}</h3>
                  </li>
                );
              })}
            </ul>
          </div>

          <h3>Yola çıxış : {selectedTour.departure}</h3>
          <h3>Yola varış : {selectedTour.arrival}</h3>

          {selectedTour.isMultipleTour === false && (
            <h3>Səyahət ölkəsi : {selectedTour.country}</h3>
          )}
          {selectedTour.isMultipleTour === true && (
            <h3>Səyahət olunacaq ölkələr : {selectedTour.countries}</h3>
          )}

          {selectedTour.isSpecialOffer === true && (
            <h3>
              Xusüsi təklif başlıqı : {selectedTour.specialOfferDescription}
            </h3>
          )}
          {selectedTour.isSpecialOffer === false && (
            <h3>Xusüsi təklif deyil</h3>
          )}

          <h3>İstək sayı : {selectedTour.requestCount}</h3>

          <h3>Başlanğıc tarixi : {selectedTour.startDate.split("T")[0]}</h3>
          <h3>Bitiş tarixi : {selectedTour.endDate.split("T")[0]}</h3>
        </div>
      </div>

      {isSuccess && (
        <Success isOpen={isSuccess} onClose={() => setIsSuccess(false)} />
      )}
    </div>
  );
};

export default TourDetailAdmin;
